type FolderOpenProps = {
  color: string;
};
export const FolderOpen = ({ color }: FolderOpenProps) => {
  return (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.4236 21.6818L39.1292 21.2931C38.6138 20.6925 38.0065 20.2155 37.3071 19.8621C36.3684 19.3498 35.3009 19.0848 34.1966 19.0848H11.2823C10.178 19.0848 9.12894 19.3498 8.17188 19.8621C7.45408 20.2331 6.8099 20.7455 6.27616 21.3815C5.22707 22.6711 4.73013 24.2611 4.89578 25.8511L5.57677 34.1015C5.81603 36.5925 6.12892 39.6665 11.9633 39.6665H33.534C39.3684 39.6665 39.6629 36.5925 39.9206 34.0838L40.6016 25.8688C40.7672 24.3848 40.3623 22.9008 39.4236 21.6818ZM27.1475 31.4338H18.3315C17.6137 31.4338 17.0431 30.8685 17.0431 30.1971C17.0431 29.5258 17.6137 28.9605 18.3315 28.9605H27.1475C27.8653 28.9605 28.4358 29.5258 28.4358 30.1971C28.4358 30.8861 27.8653 31.4338 27.1475 31.4338Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M6.88354 20.7808C7.28846 20.4275 7.69337 20.1095 8.1719 19.8621C9.11056 19.3498 10.178 19.0848 11.2824 19.0848H34.215C35.3193 19.0848 36.3684 19.3498 37.3255 19.8621C37.804 20.1095 38.2273 20.4275 38.6138 20.7985V19.8621V18.1485C38.6138 11.8415 36.6077 9.91581 30.0371 9.91581H25.6567C24.8469 9.91581 24.8285 9.89815 24.3499 9.29748L22.1413 6.45315C21.0922 5.14581 20.264 4.33315 17.6321 4.33315H15.4603C8.88969 4.33315 6.88354 6.25881 6.88354 12.5658V19.8798V20.7808Z"
        fill={color}
      />
    </svg>
  );
};
